import React from "react";
import { Route as ReactRoute, Redirect, Switch } from "react-router-dom";
import AuthRoutes from "./AuthRoutes";
import RouteContainer from "./RouteContainer";
import { RouteMap } from "./common/navigation/routeMap";
import { LogoutPage } from "./login";
import ChangePasswordPage from "./password/ChangePasswordSwitch";
import ImpersonateUser from "./login/impersonateUser";
import GrantConsentPage from "./consent/GrantConsentSwitch";

import { VerifyTwoFAPage } from "./twoFA";
import { RoleSelectionPage } from "./login";
import LoginSelectorSwitcher from "./login/LoginSelectorSwitcher";
import LoginFormSwitcher from "./login/LoginFormSwitcher";
import ExternalLoginSwitcher from "./login/ExternalLoginSwitcher";

import {
  AIA_HDF_IDS,
  AVIVA_HDF_IDS,
  GE_HDF_IDS,
  PRUDENTIAL_HDF_IDS,
  TOKIOMARINE_HDF_ID,
  AXA_HDF_IDS,
} from "./employee/hdf-forms/constants";
import {
  Aia as AiaHdfPage,
  Aviva as AvivaHdfPage,
  Ge as GeHdfPage,
  Prudential as PrudentialHdfPage,
  Tokiomarine as TokioMarineHdfPage,
  Axa as AxaHdfPage,
} from "./employee/hdf-forms";

import HdfComponent from "./employee/hdf_forms";
import GenHDF from "./employee/gen-hdf-form";

const Routes = () => (
  <Switch>
    <RouteContainer exact path="/" component={LoginSelectorSwitcher} />
    <Redirect from="/login-default" to={RouteMap.Login} />
    <RouteContainer exact path="/externallogin" component={ExternalLoginSwitcher} />
    <RouteContainer exact path={RouteMap.Login} component={LoginFormSwitcher} />
    <RouteContainer exact path="/logout" component={LogoutPage} />
    <RouteContainer exact path="/impersonateUser" component={ImpersonateUser} />

    <RouteContainer
      requireAuth
      exact
      path="/grantConsent"
      authAction="GrantConsent"
      component={GrantConsentPage}
    />
    <RouteContainer
      requireAuth
      exact
      path="/resetExpiredPassword"
      authAction="ResetExpiredPassword"
      component={ChangePasswordPage}
    />
    <RouteContainer
      requireAuth
      exact
      path="/verify2fa"
      authAction="TwoFARequired"
      component={VerifyTwoFAPage}
    />
    <RouteContainer
      requireAuth
      exact
      path="/selectRole"
      authAction="RoleSelectionRequired"
      component={RoleSelectionPage}
    />

    {AIA_HDF_IDS.map(id => (
      <RouteContainer
        key={`hdf_${id}`}
        requireAuth
        exact
        path={`/hdf/${id}/:planYearId?/:enrolmentKey?`}
        component={AiaHdfPage}
      />
    ))}

    {GE_HDF_IDS.map(id => (
      <RouteContainer
        key={`hdf_${id}`}
        requireAuth
        exact
        path={`/hdf/${id}/:planYearId?/:enrolmentKey?`}
        component={GeHdfPage}
      />
    ))}

    {AVIVA_HDF_IDS.map(id => (
      <RouteContainer
        key={`hdf_${id}`}
        requireAuth
        exact
        path={`/hdf/${id}/:planYearId?/:enrolmentKey?`}
        component={AvivaHdfPage}
      />
    ))}

    {PRUDENTIAL_HDF_IDS.map(id => (
      <RouteContainer
        key={`hdf_${id}`}
        requireAuth
        exact
        path={`/hdf/${id}/:planYearId?/:enrolmentKey?`}
        component={PrudentialHdfPage}
      />
    ))}

    <RouteContainer
      requireAuth
      exact
      path={`/hdf/${TOKIOMARINE_HDF_ID}/:planYearId?/:enrolmentKey?`}
      component={TokioMarineHdfPage}
    />

    {AXA_HDF_IDS.map(id => (
      <RouteContainer
        key={`hdf_${id}`}
        requireAuth
        exact
        path={`/hdf/${id}/:planYearId?/:enrolmentKey?`}
        component={AxaHdfPage}
      />
    ))}

    <RouteContainer
      requireAuth
      exact
      path={`/hdf/:hdfId/:planYearId?/:enrolmentKey?`}
      component={HdfComponent}
    />

    <RouteContainer
      requireAuth
      exact
      path={`/gen-hdf/:hdfId/:planYearId?/:enrolmentKey?`}
      component={GenHDF}
    />

    <ReactRoute component={AuthRoutes} />
  </Switch>
);

export default Routes;



// WEBPACK FOOTER //
// ./components/Routes.jsx